<template>
    <div class="sidebar">
        <Overlay v-if="this.loading"></Overlay>
        <Loading v-if="this.loading"></Loading>
        <div class="sidebar-wrapper">
            <ul class="nav">
                <button class="btn btn-link" v-on:click="retrieveBoards()" style="position:absolute; right:0; top:12px; z-index:99;"><i class="material-icons">refresh</i></button>
                <menu-item navname="boards" name="Boards" icon="notes">
                    <menu-item v-for="board in boards"
                               :key="board.id"
                               ischild="1"
                               :icon="board.icon"
                               navtype="boards"
                               v-tooltip="getTooltip(board.id)"
                               v-bind:name="board.name"
                               v-bind:itemid="board.id"
                               @onChange="changeToSection"
                               v-bind:isactive="isActive('boards'+board.id)"></menu-item>
                </menu-item>
                <hr style="color:#D7B615; background-color:#D7B615;"/>
                <menu-item v-if="this.$root.hasPermForAdmin('assignRoles')" :isactive="isActive('adminAssignPerms')" @onChange="changeToSection" navtype="admin" itemid="AssignPerms" icon="supervisor_account" name="Assign perms" isadmin="1"></menu-item>
                <menu-item v-if="this.$root.hasPermForAdmin('createBoard')" :isactive="isActive('adminNewBoard')" @onChange="changeToSection" navtype="admin" itemid="NewBoard" icon="assignment" name="Create new board" isadmin="1"></menu-item>
            </ul>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import MenuItem from '../components/MenuItem.vue'
import ApiService from "../common/api.service";
import Loading from "./Loading";
import Overlay from "./Overlay";

export default {
    name: 'sidebar',
    data() {
        return {
            loading: false,
            boards: []
        }
    },
    components: {
        MenuItem,
        Loading,
        Overlay
    },
    methods: {
        getTooltip(boardId){
            return (this.$root.hasPermForAdmin('assignRoles') ? 'ID: '+boardId : null);
        },
        isActive(name){
            let nav = this.$root.navigation;
            return (nav.navType+nav.itemId) == name;
        },
        changeToSection(navType, name, itemId){
            if(navType == 'boards')
                this.$root.changeToBoard(name, itemId);

            this.$root.setNavigating(navType, itemId);
        },
        retrieveBoards(){
            this.loading = true;
            axios
                .get(ApiService.getAction('boards', 'get'))
                .then(response => {
                    console.log(response);
                    this.boards = response.data.boards;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => this.loading = false)
        }
    },
    mounted(){
        this.retrieveBoards();
    }
}
</script>
